import { CSSProperties, Fragment } from 'react';

import { Divider, FlexAligner } from '@scaleaq/scaleui';

import { HotKeyLineWithButtonAndDescription } from '@/components/HotKeyLineWithButtonAndDescription.tsx';
import { useGlobalHotkeysDefinitions } from '@/hooks/shortcutHooks/useHotkeyDefinitions/useGlobalHotkeysDefinitions.tsx';
import { responsive } from '@/utils';

const DEFAULT_STYLE: CSSProperties = {
  width: '32rem',
  height: 'fit-content',
};

type LayoutShortcutsProps = {
  style?: CSSProperties;
};

export const GlobalShortcuts = ({ style = DEFAULT_STYLE }: LayoutShortcutsProps) => {
  const globalHotkeyGroups = useGlobalHotkeysDefinitions();
  return (
    <FlexAligner
      direction='column'
      alignment={'center'}
      style={{ ...style }}
      gap={responsive.spacing['3xlarge']}
    >
      {globalHotkeyGroups.map((globalHotkeys, index) => (
        <Fragment key={Object.keys(globalHotkeys).join('-')}>
          {index > 0 && <Divider />}
          {Object.values(globalHotkeys).map(props => (
            <HotKeyLineWithButtonAndDescription key={props.primary.code} {...props} />
          ))}
        </Fragment>
      ))}
    </FlexAligner>
  );
};
